<template>

    <div>

        <b-row style="margin: 7px;">
            <b-col>
                <b-form-input @change="dataChangedEvent()" v-model="egData.text" placeholder="Example text"></b-form-input>
            </b-col>

            <b-col lg="2">
                <b-form-select 
                id="input-3" 
                v-model="egData.language" 
                :options="languages" 
                required 
                value-field="code"
                text-field="name"
                @change="dataChangedEvent()"
                ></b-form-select>
            </b-col>

            <b-col>
                <b-button variant="danger" @click="exampleDeletedEvent(idx)">Delete</b-button>
            </b-col>
        </b-row>
    </div>

</template>

<script>
export default {
  name: 'EgItem',
  props: {
    egData: {
      type: Object | String
    },
    slotsData: {
      type: Array | Object
    },

    dataChangedEvent: {
        type: Function
    } ,
    languages: {
        type: Array | Object
    },
    idx : {
        type: Number
    },
    exampleDeletedEvent: {
        type: Function
    }
  },
    methods: {

        stringTOId(str, egidx) {
            return str + "-" + egidx;
        },
    },
    mounted() {
        console.log('mounted');
        // console.log(this.egData);
        // console.log(this.slotsData);
    }
}

</script>